import { motion } from "framer-motion";
import { Star, Quotes } from "@phosphor-icons/react";

const TESTIMONIALS = [
  {
    quote: "We have never found a better, more affordable, trustworthy, reliable or knowledgeable mechanic anywhere we've ever lived.",
    name: "Sarah M.",
    detail: "Customer for 5+ years",
  },
  {
    quote: "He explains how things work, what's wrong, and always looks for the best and least expensive options. I wouldn't take my car anywhere else.",
    name: "David K.",
    detail: "Honda Accord, 280k miles",
  },
  {
    quote: "I was quoted $3,700 at another shop. I brought it to Vu for a second opinion, and he fixed exactly what was actually needed for $680.",
    name: "Jennifer L.",
    detail: "Saved over $3,000",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.15 },
  }),
};

export default function Testimonials() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 md:py-32 bg-card">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="uppercase text-xs tracking-[0.2em] text-muted-foreground font-medium mb-4"
        >
          Customer Reviews
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-none mb-16 max-w-xl"
        >
          Don't take our word for it. <span className="text-primary">Hear from our community.</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={cardVariants}
              className="bg-background border border-stone-200 rounded-xl p-8 md:p-10 flex flex-col justify-between group hover:border-primary/30 transition-colors duration-300"
              data-testid={`testimonial-card-${i}`}
            >
              <div>
                <Quotes weight="fill" className="w-8 h-8 text-primary/30 mb-4" />
                <p className="text-foreground leading-relaxed text-sm md:text-base mb-6">
                  "{t.quote}"
                </p>
              </div>
              <div className="flex items-center justify-between pt-6 border-t border-stone-200">
                <div>
                  <p className="font-heading font-bold text-sm">{t.name}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{t.detail}</p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} weight="fill" className="w-4 h-4 text-amber-400" />
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Average rating banner */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 text-center"
        >
          <div className="flex gap-1">
            {[...Array(5)].map((_, j) => (
              <Star key={j} weight="fill" className="w-5 h-5 text-amber-400" />
            ))}
          </div>
          <p className="text-muted-foreground text-sm">
            <span className="font-heading font-bold text-foreground">4.7 out of 5</span> — based on local community reviews
          </p>
        </motion.div>
      </div>
    </section>
  );
}
